import { DefaultTheme, rgba } from '../../components/theme';
import { ColorPaletteOrange, ColorPaletteRed } from '../../components/theme.palette';

export const CSS = {
	container: 'c-TagList__selected',
	title: 'c-TagList__selected_title',
	text: 'c-TagList__selected_text',
	tools: 'c-TagList__selected_tools',
	spanomatic: 'c-Span-O-Matic',
};

export const Style = {
	[CSS.container]: {
		paddingLeft: DefaultTheme.space(2),
		paddingRight: DefaultTheme.space(2),
		fontSize: '120%',
		backgroundColor: rgba(ColorPaletteOrange.C100),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		height: DefaultTheme.space(10),
		minHeight: DefaultTheme.space(10),
	},
	[CSS.title]: {
		flex: 1,
		overflow: 'hidden',
		'text-overflow': 'ellipsis',
		'white-space': 'nowrap',
	},
	[CSS.text]: {
		flex: 1,
		overflow: 'hidden',
		'text-overflow': 'ellipsis',
		'white-space': 'nowrap',
		padding: `0 ${DefaultTheme.space(1)}`,
	},
	// Icon buttons carry an explicit height, so a stretch-aligned row pins them to the top of the tallest
	// sibling — and the sort control is taller, which shifted the icons between the two toolbar modes.
	[CSS.tools]: {
		display: 'flex',
		alignItems: 'center',
	},
	[CSS.spanomatic]: {
		color: `rgb(${ColorPaletteRed.A700})`,
	},
};
